import React from 'react';
import uuid from 'uuid/v1';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import { Grid, Paper, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import HtmlIcon from '@mui/icons-material/Html';

import LayerEditorMaps from '../LayerEditorMaps';

const InfoLayerSelection = ({ featureProp, map }) => {
  const [propertiesArray, setPropertiesArray] = React.useState([]);
  const [verHtml, setVerHtml] = React.useState(map.selectedButtons.ViewHtml);

  React.useEffect(() => {
    if (isEmpty(featureProp.properties) === false) {
      const informacion = Object.entries(featureProp.properties).map(([key, value]) => ({
        key,
        value
      }));
      setPropertiesArray(informacion);
    }
  }, [featureProp]);

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#757575',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const MaterialUISwitch = styled(Switch)(() => ({
    width: 44,
    height: 22,
    padding: 0,
    margin: 9,
    // display: 'flex',
    transition: 'all .2s',
    borderRadius: 22 / 2,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      opacity: 1,
      backgroundColor: '#2A3F90',
      boxSizing: 'border-box',
      border: '1px solid #2A3F90'
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 17,
      height: 17,
      borderRadius: 17,
      backgroundColor: 'white'
    },
    '& .Mui-disabled + span': {
      backgroundColor: '#9f9f9f',
      border: '1px solid #2A3F90'
    },
    '& .MuiSwitch-switchBase': {
      padding: 2.5,
      '&.Mui-focusVisible': {
        backgroundColor: 'rgba(198, 203, 212, 0.3)',
        '& .MuiSwitch-thumb': {
          backgroundColor: '#777E8C'
        }
      },
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#2A3F90',
          boxSizing: 'border-box',
          border: '1px solid #2A3F90'
        },
        '& .MuiSwitch-thumb': {
          opacity: 1,
          backgroundColor: 'white'
        },
        // ! change width / padding if necessary
        '& svg': {
          width: 15,
          height: 15,
          borderRadius: 17,
          padding: 1,
          backgroundColor: 'white'
        },
        '&.Mui-disabled + span': {
          backgroundColor: '#e4eaf6',
          border: 'none'
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          backgroundColor: 'white'
        }
      }
    }
  }));

  return (
    <>
      {isEmpty(propertiesArray) ? (
        <Grid container direction="row" justifyContent="space-around" alignItems="stretch">
          <Typography variant="h5" gutterBottom>
            Selecciona un punto en el mapa
          </Typography>
        </Grid>
      ) : (
        <TableContainer component={Paper}>
          {verHtml === true ? (
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">
                    {featureProp.name}
                    <MaterialUISwitch
                      checked={verHtml}
                      checkedIcon={<HtmlIcon />}
                      onClick={() => {
                        setVerHtml(!verHtml);
                      }}
                      label={verHtml === true ? 'Html' : 'Texto'}
                      color="primary"
                    />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertiesArray.map(({ key, value }) => (
                  <StyledTableRow
                    key={uuid()}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center" width="50%" title={key}>
                      {/* eslint-disable-next-line react/no-danger */}
                      <div dangerouslySetInnerHTML={{ __html: value }} />
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">Layer</StyledTableCell>
                  <StyledTableCell align="center">
                    {featureProp.name}
                    <MaterialUISwitch
                      checked={verHtml}
                      checkedIcon={<HtmlIcon />}
                      onClick={() => {
                        setVerHtml(!verHtml);
                      }}
                      label={verHtml === true ? 'Html' : 'Texto'}
                      color="primary"
                    />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertiesArray.map(({ key, value }) => (
                  <StyledTableRow
                    key={uuid()}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center" width="50%">
                      {key}
                    </TableCell>
                    <TableCell align="center" width="50%">
                      {value}
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      )}
      <br />
      {map.selectedButtons.LayerEditor === true && <LayerEditorMaps />}
    </>
  );
};

InfoLayerSelection.defaultProps = {
  featureProp: {},
  LayerEditor: false,
  map: {}
};
InfoLayerSelection.propTypes = {
  featureProp: PropTypes.object,
  LayerEditor: PropTypes.bool,
  map: PropTypes.object
};

export default InfoLayerSelection;
